module.exports = __webpack_public_path__ + "img/WP.e1b407aa.svg";